"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _form = require("../../form");

var _helperComponents = require("../../form/input/helperComponents");

var _utils = require("../../form/utils");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _screenReaderOnly = require("../../screen-reader-only");

var _utils2 = require("../../utils");

var _dateTimeSegments = require("../date-time-segments");

var _helperComponents2 = require("../helperComponents");

var _DateTimeInputContainer = _interopRequireDefault(require("./DateTimeInputContainer"));

var _constants = require("./constants");

var _utils3 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["ariaLabels", "calendarButtonAltText", "calendarButtonRef", "clearButtonAltText", "containerRef", "datePickerProps", "handleChange", "handleToggle", "id", "inputProps", "isOpen", "isReadOnly", "labelIdProp", "locale", "segmentValues", "showSeconds", "showMilliseconds"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateTimeInputComponentBase = function DateTimeInputComponentBase(_ref) {
  var ariaLabels = _ref.ariaLabels,
      calendarButtonAltText = _ref.calendarButtonAltText,
      calendarButtonRef = _ref.calendarButtonRef,
      clearButtonAltText = _ref.clearButtonAltText,
      containerRef = _ref.containerRef,
      datePickerProps = _ref.datePickerProps,
      handleChange = _ref.handleChange,
      handleToggle = _ref.handleToggle,
      id = _ref.id,
      inputProps = _ref.inputProps,
      isOpen = _ref.isOpen,
      isReadOnly = _ref.isReadOnly,
      labelIdProp = _ref.labelIdProp,
      locale = _ref.locale,
      segmentValues = _ref.segmentValues,
      showSeconds = _ref.showSeconds,
      showMilliseconds = _ref.showMilliseconds,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shouldFocusFirstSegment = _useState2[0],
      setShouldFocusFirstSegment = _useState2[1];

  var dataTestProps = (0, _utils2.pick)(forwardedProps, _utils2.dataTestKeys);
  var disabled = inputProps.disabled;
  var hasSegmentValues = (0, _utils3.hasAnySegmentValue)(segmentValues);
  var currentDateUTCString = (0, _utils3.dateTimeSegmentsToDate)(segmentValues, !!showSeconds, !!showMilliseconds).toUTCString();

  var handlePaste = function handlePaste(e) {
    var pastedString = e.clipboardData.getData('Text');

    if ((0, _utils3.isIsoFormat)(pastedString)) {
      handleChange((0, _utils3.dateStringToSegments)(pastedString));
    }

    e.preventDefault();
  };

  var handleClearButtonClick = function handleClearButtonClick() {
    var emptySegmentValues = _objectSpread({}, segmentValues);

    Object.keys(emptySegmentValues).forEach(function (segment) {
      emptySegmentValues[segment] = undefined;
    });
    handleChange(emptySegmentValues);
    setShouldFocusFirstSegment(true);
  };

  var handleContainerClick = function handleContainerClick() {
    if (containerRef && containerRef.current) {
      var hasFocus = containerRef.current.contains((0, _utils2.getActiveElement)(containerRef.current, {
        closedShadowDom: true
      }));

      if (!hasFocus) {
        setShouldFocusFirstSegment(true);
      }
    }
  };

  var labelId = labelIdProp || (0, _utils.buildLabelId)(id);
  var valueStringId = (0, _utils3.buildValueStringId)(id);
  var ariaDescribedBy = datePickerProps['aria-describedby'],
      ariaRequired = datePickerProps['aria-required'],
      ariaInvalid = datePickerProps['aria-invalid'];
  return (0, _core.jsx)(_DateTimeInputContainer.default, (0, _extends2.default)({
    ref: containerRef
  }, dataTestProps, inputProps, {
    onClick: handleContainerClick,
    onPaste: handlePaste
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, (0, _core.jsx)("time", {
    id: valueStringId
  }, hasSegmentValues && currentDateUTCString)), (0, _core.jsx)(_layout.Row, {
    flexWrap: "wrap",
    role: "group",
    "aria-labelledby": "".concat(labelId, " ").concat(valueStringId),
    alignItems: "center"
  }, (0, _core.jsx)(_dateTimeSegments.DateTimeSegments, {
    id: id,
    segmentValues: segmentValues,
    onChange: handleChange,
    disabled: disabled,
    isReadOnly: isReadOnly,
    showDate: true,
    showTime: true,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds,
    locale: locale,
    labelId: labelId,
    ariaLabels: ariaLabels,
    ariaDescribedBy: ariaDescribedBy,
    ariaRequired: ariaRequired,
    ariaInvalid: ariaInvalid,
    shouldFocusFirstSegment: shouldFocusFirstSegment,
    onFirstSegmentFocus: function onFirstSegmentFocus() {
      return setShouldFocusFirstSegment(false);
    }
  })), !disabled && (0, _core.jsx)(_helperComponents.InsetElementContainer, {
    inset: _constants.INSET_ELEMENT_DEFAULTS.inset,
    isTrailing: true
  }, (0, _core.jsx)(_layout.Row, null, (0, _core.jsx)(_helperComponents2.DatePickerButton, {
    ref: calendarButtonRef,
    "aria-expanded": isOpen,
    "aria-label": calendarButtonAltText,
    icon: (0, _core.jsx)(_icons.IconCalendar, {
      "aria-hidden": true
    }),
    onClick: handleToggle,
    size: _button.ButtonSize.Small,
    title: calendarButtonAltText,
    variant: _button.ButtonVariant.Tertiary
  }), hasSegmentValues && (0, _core.jsx)(_form.InputClearButton, {
    altText: clearButtonAltText,
    onClick: handleClearButtonClick
  }))));
};

var DateTimeInputComponent = (0, _utils2.withTestAttributes)({})(DateTimeInputComponentBase);
var _default = DateTimeInputComponent;
exports.default = _default;